import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';
import ReactDOM from 'react-dom';
import SweetScroll from 'sweet-scroll';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import axios from 'axios';
import qs from 'qs';
import { shuffle } from 'lodash';
import translate from '../../utils/translate';

import { dispatchError, dispatchMsg } from '../../actions/errors';

import { casesRoute } from '../../routes';
import Spinner from '../../components/svg/spinner';
import ContentBlock from '../../components/account/block/content';
import Splitter from '../../components/account/block/splitter';
import Share from '../../components/share/share';
import Countdown from '../../components/countdown/countdown';
import Image from '../../components/image/image';
import ConfirmDialog from '../../components/form/confirm';

import formatCredits from '../../utils/formatCredits';
import css from './publicvoting.scss';

class PublicVoting extends Component {
	static propTypes = {
		browser: PropTypes.object.isRequired,
		dispatch: PropTypes.func.isRequired,

		blurb: PropTypes.string.isRequired,
		head: PropTypes.string.isRequired,
		subhead: PropTypes.string.isRequired,
		about: PropTypes.string.isRequired,
		sponsor: PropTypes.oneOfType([
			PropTypes.object,
			PropTypes.bool,
		]),
		ribbonStyle: PropTypes.string.isRequired,
		voteUrl: PropTypes.string.isRequired,
	};

	constructor(props) {
		super(props);

		this.mounted = true;

		this.state = {
			cases: [],
			loading: true,
			data: {},
		};
	}

	componentWillMount() {
		this.getCases();
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		const { browser, sponsor, ribbonStyle } = this.props;
		const { data, cases } = this.state;
		const { alreadyVoted, isVotingOpen, roundText, nextDate, linkAbout } = data;
		let listClass = 'account-cases__list-container account-cases__list-container--active';

		if (this.state.loading || !data) {
			return (
				<Spinner className='case-single__spinner' size='80px' />
			);
		}

		let sponsorImg = false;
		if (sponsor) {
			sponsorImg = <img {...sponsor} alt='TCEAY Sponsor' />
		}

		return (
			<div className='publicvoting'>
				<Helmet title={`The FWA - Public Voting - ${translate(this.props.head)}`} />
				<div className='publicvoting__head'>
					<div className='publicvoting__head__blurb push5 push0-tablet push0-mobile'>{translate(this.props.blurb)}</div>
					<div className='publicvoting__head__share'>
						<Share browser={browser} title={translate(this.props.head)} />
					</div>
				</div>

				<ContentBlock title={<span className='publicvoting__head__sponsorlogo'>{sponsorImg}</span>} className='publicvoting__head__text'>
					<div className='account-process__title-area span7 span10-tablet span14-mobile'>
						<strong>{translate(this.props.head)}</strong><br />

						{translate(this.props.subhead)}
					</div>
				</ContentBlock>

				<ContentBlock title={<span>About the voting process</span>} className='account-block-content--small-aside account-block-content--nopad'>
					<div className='span7-tablet span14-mobile account-jury__col2 account-jury__scorecard__intro'>
						<p dangerouslySetInnerHTML={{ __html: translate(this.props.about) }}></p>

						<br />
						<br />

						{(isVotingOpen) && (
							<button
								className='button--dark'
								onClick={() => {
									const scroller = new SweetScroll({ easing: 'easeOutQuint', offset: -60, duration: 1000 });
									let element = ReactDOM.findDOMNode(this.refs.msg);
									scroller.toElement(element);
								}}
							>
								Go to voting
							</button>
						)}

						<br />
						<br />
					</div>

					<div className='span0 span5-tablet hide-mobile account-jury__col1'></div>
					<div className='span7-tablet span14-mobile account-jury__col3' style={{ paddingTop: 0 }}>
						{(!!linkAbout) && (
							<div>
								<p className='account-jury__linklist-head'>Read more</p>
								<ol className='account-jury__linklist'>
									<li className='account-jury__linklist__item'><Link to={linkAbout.url}>{linkAbout.text}</Link></li>
								</ol>
							</div>
						)}
					</div>
				</ContentBlock>

				<Splitter />

				<ContentBlock title={roundText} className='publicvoting__votehead'>
					<span className='publicvoting__votehead__status'>{isVotingOpen ? 'Voting ends in:' : 'Voting starts in:'}</span>
				</ContentBlock>

				<div className='publicvoting__countdown'>
					<Countdown timeLeft={(nextDate - (Date.now() / 1000))} spans='span14' />
				</div>

				<div className='cf'></div>

				<ContentBlock title={(!!alreadyVoted) ? 'Thank you for voting!' : ''} className='publicvoting__spacer' ref='msg' />

				<div className='publicvoting__list-container'>
					<ConfirmDialog ref='confirm' />
					<ul className='publicvoting__case-holder span12 span14-mobile'>
						{cases.map((caseItem, i) => {
							const uid = `case${i}`;
							const credits = formatCredits(caseItem.profiles, false, false);
							return (
								<li key={uid} className='publicvoting__case span3 span6-tablet span14-mobile'>
									<div className='contextual-menu__inner-list__cases__case contextual-menu__inner-list__cases__case--light span3 span6-tablet span14-mobile'>
										<Link to={casesRoute(caseItem.slug)} target='_blank' className='publicvoting__case__voteholder'>
											{caseItem.thumbnail && (
												<div className='contextual-menu__inner-list__cases__case__image pixel-pattern pixel-pattern--darker'>
													<div className={`ribbon-${ribbonStyle} ribbon-${ribbonStyle}--tr ribbon-${ribbonStyle}--small`}></div>
													<Image img={caseItem.thumbnail} span={{ desktop: 'span4', tablet: 'span6', mobile: 'span14' }} browser={this.props.browser} />

													<div className='publicvoting__case__voteholder__btns'>
														<div className="publicvoting__case__voteholder__btns__pos">
															<div className='button button--dark-to-light-anim publicvoting__case__voteholder__btns__btn'>See Case</div>
															{!alreadyVoted && (
																<div className='button button--light-to-dark-anim publicvoting__case__voteholder__btns__btn' onClick={(e) => this.submitVote(e, caseItem)}>Vote</div>
															)}
														</div>
													</div>
												</div>
											)}
											<div className='contextual-menu__inner-list__cases__case__content'>
												<h2 className='contextual-menu__inner-list__cases__case__title'>{caseItem.title}</h2>
												<span className='contextual-menu__inner-list__cases__case__byline'>{credits}</span>
											</div>
										</Link>
									</div>
								</li>
							);
						})}
						<li className='publicvoting__case-fill span3 span6-tablet span14-mobile'></li>
						<li className='publicvoting__case-fill span3 span6-tablet span14-mobile'></li>
						<li className='publicvoting__case-fill span3 span6-tablet span14-mobile'></li>
					</ul>

					<div className='account-cases__fill span2 span2-plus hide-mobile'></div>

					<div className='cf'></div>
				</div>
			</div>
		);
	}

	getCases(success = () => {}, fail = () => {}) {
		axios.get(this.props.voteUrl)
		.then((res) => {
				// console.log(res.data);
				if (res.data) {
					const newState = {
						loading: false,
						data: res.data,
					};

					if (!this.state.cases.length) {
						newState.cases = shuffle(res.data.cases) || [];
					}

					this.mounted && this.setState(newState);

					success();
				}
			})
		.catch((res) => {
			this.mounted && this.setState({
						loading: false,
					});

				if (res.data && res.data.message) {
					this.props.dispatch(dispatchError(res.data));
				}

				fail();
			});
	}

	submitVote(e, caseItem) {
		e.preventDefault();
		e.stopPropagation();
		// console.log(caseItem);

		this.refs.confirm.confirm(translate(this.props.confirm).replace('%title%', caseItem.title), 'Yes', 'No')
			.then(() => {
			axios.post(this.props.voteUrl + '/vote', qs.stringify({
							id: caseItem.id,
			}))
			.then((res) => {
						if (res.data && res.data.message) {
							this.props.dispatch(dispatchMsg(res.data));
							this.getCases(() => {
						const scroller = new SweetScroll({ easing: 'easeOutQuint', offset: -60, duration: 1000 });
								let element = ReactDOM.findDOMNode(this.refs.msg);
								scroller.toElement(element);
							});
						}
					})
			.catch((res) => {
						// show error msg
						if (res.data && res.data.message) {
							this.props.dispatch(dispatchError(res.data));
							this.getCases();
						}
			})
		}).catch(() => {
				// do nothing
			});
	}
}

export default connect((state) => ({ browser: state.browser }))(PublicVoting);



/** WEBPACK FOOTER **
 ** ./frontend/containers/publicvoting/publicvoting.js
 **/